import { render, staticRenderFns } from "./MobileOnly.vue?vue&type=template&id=2768f3a6&scoped=true&"
import script from "./MobileOnly.vue?vue&type=script&lang=ts&"
export * from "./MobileOnly.vue?vue&type=script&lang=ts&"
import style0 from "./MobileOnly.vue?vue&type=style&index=0&id=2768f3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768f3a6",
  null
  
)

export default component.exports